<template>
  <ion-page>
    <main-header></main-header>
    <ion-content padding="true">
      <h1 class="ion-text-center">404 - Not Found</h1>
      <ion-grid>
        <ion-row>
          <ion-col class="ion-text-center" size="12" size-md>
            <p>
              Sorry, you can't Stay Seated here.
            </p>
            <p>
              <ion-button @click="$router.push('/')"
                >Get me to where I need to be</ion-button
              >
            </p>
          </ion-col>
          <ion-col class="ion-text-center" size="12" size-md>
            <img src="./reserved.jpg" alt="Reserved seat" class="not-found" />
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
export default {
  title: "Not Found"
};
</script>

<style>
.not-found {
  max-height: 50vh;
}
</style>
